// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"f447bc0e296baa0b24b9","404":"97c616a75073ae5077d6","406":"2dc3af74f57313019007"}[chunkId] + ".css";
};